<template>
    <main>
        <div class="J-chat-container J-conversation">
            <div class="J-chat-avatar-content">
                <a href="javascript:void(0)" @click="isTabActive(1)" class="J-icon-back">
                    <i class="fas fa-angle-left"></i>
                </a>
                <v-avatar size="60px">
                   <img :src="imageUrl" alt="Avatar">
                </v-avatar>
                <div class="J-chat-message-content">
                    <div class="J-chat-name">
                        <span>
                            {{office.name}}
                        </span>
                    </div>
                </div>
                
            </div>
        </div>
        <span  v-for="message in data" :key="message.id" >
            <div  class="J-chat-container" v-if="message._id_conversation.fullname" @click="selectUser(message._id_conversation)">
                    <div class="J-chat-avatar-content">
                        <v-avatar size="60px">
                            <img :src="message._id_conversation.photo[0].link" alt="Avatar">
                        </v-avatar>
                    </div>
                    <div class="J-chat-message-content">
                        <div class="J-chat-name">
                            <span>
                                {{message._id_conversation.fullname}}
                            </span>
                        </div>
                        <div class="J-chat-message">
                            <span>
                                {{message.conversation[0].message}}
                            </span>
                        </div>
                        <span v-if="message.count!=0" class="J-count-number">{{message.count}}</span>
                    </div>
            </div>
                <div class="J-chat-container"  v-else  @click="selectUser(message._id_conversation)">
                     <div class="J-chat-avatar-content">
                        <v-avatar size="60px" v-if="message._id_conversation.image_company">
                           <img :src="message._id_conversation.image_company.link" alt="Avatar">
                        </v-avatar>
                    </div>
                    <div class="J-chat-message-content">
                        <div class="J-chat-name">
                            <span>
                                {{message._id_conversation.name}}
                            </span>
                        </div>
                        <div class="J-chat-message">
                            <span>
                                {{message.conversation[0].message}}
                            </span>
                        </div>
                        <span v-if="message.count!=0" class="J-count-number">{{message.count}}</span>
                    </div>
                </div>
        </span>
    </main>
</template>
<script>
    import { EventBus } from '../../../../helpers/eventbus/event-bus'
    export default {
        data(){
            return{
              imageUrl: 'https://picsum.photos/510/300?random',
            }   
        },
        
        props:{
            data:null,
            office:{type:Object,required:false}
        },

        created(){
            this.countMessage()
            if(this.office){
                if(this.office.photo){
                    if(this.office.photo[0]){
                        //this.imageUrl= this.office.photo[0].link;
                    }
                }
            }
        },
        methods:{
            isTabActive:function(i){
                this.$emit('back',i)
            },
            selectUser:function(id){
                this.$emit('select',id)
            },
            countMessage:function(){
                var data=0;
                EventBus.$emit('countmessage',data);
            }
        }
    }
</script>

